import React, { useEffect, useRef, useSyncExternalStore } from "react";
import BluefieldLogo from "./assets/logo.png";

let nextSpinnerId = 1;
const mountedSpinnerIds = [];
const spinnerSubscribers = new Set();

const notifySpinnerSubscribers = () => {
  spinnerSubscribers.forEach((callback) => callback());
};

const subscribeToSpinnerStore = (callback) => {
  spinnerSubscribers.add(callback);
  return () => spinnerSubscribers.delete(callback);
};

const getPrimarySpinnerId = () => mountedSpinnerIds[0] ?? null;

export const Spinner = () => {
  const spinnerIdRef = useRef(null);
  if (spinnerIdRef.current === null) {
    spinnerIdRef.current = nextSpinnerId++;
  }

  useEffect(() => {
    const id = spinnerIdRef.current;
    mountedSpinnerIds.push(id);
    notifySpinnerSubscribers();

    return () => {
      const index = mountedSpinnerIds.indexOf(id);
      if (index !== -1) {
        mountedSpinnerIds.splice(index, 1);
      }
      notifySpinnerSubscribers();
    };
  }, []);

  const primarySpinnerId = useSyncExternalStore(
    subscribeToSpinnerStore,
    getPrimarySpinnerId,
    getPrimarySpinnerId
  );

  if (primarySpinnerId !== spinnerIdRef.current) {
    return null;
  }

  return (
    <div className="loader-backdrop">
      <div className="circular-loader">
        <div className="loader-ring" />
        <img
          src={BluefieldLogo}
          alt="Loading"
          className="bluefield-logo-center"
        />
      </div>
    </div>
  );
};
